export const DISCOUNT_REQUEST = "DISCOUNT_REQUEST";
export const DISCOUNT_SUCCESS = "DISCOUNT_SUCCESS";
export const DISCOUNT_ERROR = "DISCOUNT_ERROR";

export const DISCOUNT_ADD_REQUEST = "DISCOUNT_ADD_REQUEST";
export const DISCOUNT_ADD_SUCCESS = "DISCOUNT_ADD_SUCCESS";
export const DISCOUNT_ADD_ERROR = "DISCOUNT_ADD_ERROR";

export const DISCOUNT_REMOVE_REQUEST = "DISCOUNT_REMOVE_REQUEST";
export const DISCOUNT_REMOVE_SUCCESS = "DISCOUNT_REMOVE_SUCCESS";
export const DISCOUNT_REMOVE_ERROR = "DISCOUNT_REMOVE_ERROR";

export const DISCOUNT_BLOCK_REQUEST = "DISCOUNT_BLOCK_REQUEST";
export const DISCOUNT_BLOCK_SUCCESS = "DISCOUNT_BLOCK_SUCCESS";
export const DISCOUNT_BLOCK_ERROR = "DISCOUNT_BLOCK_ERROR";

export const DISCOUNT_TRANSACTIONS_REQUEST = "DISCOUNT_TRANSACTIONS_REQUEST";
export const DISCOUNT_TRANSACTIONS_SUCCESS = "DISCOUNT_TRANSACTIONS_SUCCESS";
export const DISCOUNT_TRANSACTIONS_ERROR = "DISCOUNT_TRANSACTIONS_ERROR";

export const DISCOUNT_BONUS_INFO_REQUEST = "DISCOUNT_BONUS_INFO_REQUEST";
export const DISCOUNT_BONUS_INFO_SUCCESS = "DISCOUNT_BONUS_INFO_SUCCESS";
export const DISCOUNT_BONUS_INFO_ERROR = "DISCOUNT_BONUS_INFO_ERROR";